import { inject, Injectable } from '@angular/core';
import { CoreService } from './core.service';
import { environment } from 'src/environments/environment';
import { StorageService } from '../shared/storage.service';
import { STORAGE_KEYS } from '../utils/constants';

@Injectable({ providedIn: 'root' })
export class ApiService extends CoreService {
  storageService = inject(StorageService);

  override get<T = any>(url: string, options?: any) {
    return this.request<T>('get', url, { ...options, headers: this.getHeaders(options) });
  }
  override post<T = any>(url: string, options?: any) {
    return this.request<T>('post', url, { ...options, headers: this.getHeaders(options) });
  }
  override put<T = any>(url: string, options?: any) {
    return this.request<T>('put', url, { ...options, headers: this.getHeaders(options) });
  }
  override patch<T = any>(url: string, options?: any) {
    return this.request<T>('patch', url, { ...options, headers: this.getHeaders(options) });
  }
  override delete<T = any>(url: string, options?: any) {
    return this.request<T>('delete', url, { ...options, headers: this.getHeaders(options) });
  }

  private getHeaders(options) {
    const headers = options?.headers ?? {};

    // Modo cookie (Fase 2): el JWT viaja en la cookie httpOnly `sp_session` (no header).
    // Se refleja el token CSRF (cookie legible `sp_csrf`) en X-CSRF-Token para el
    // double-submit del backend. Si un caller ya puso un Authorization explícito, se respeta.
    if (environment.useCookieAuth) {
      const csrf = this.readCsrfCookie();
      return {
        ...headers,
        ...(csrf ? { 'X-CSRF-Token': csrf } : {}),
      };
    }

    return {
      ...headers,
      Authorization:
        headers.Authorization ?? `Bearer ${this.storageService.get(STORAGE_KEYS.AUTH_TOKEN)}`,
    };
  }

  private readCsrfCookie(): string | undefined {
    if (typeof document === 'undefined' || !document.cookie) return undefined;
    const m = document.cookie.match(/(?:^|;\s*)sp_csrf=([^;]+)/);
    return m ? decodeURIComponent(m[1]) : undefined;
  }
}
